export default __webpack_public_path__ + "7cae49f126d9e218847a3b8b28f3d5e4.png";